// Brand Configuration - Centralized brand settings for PCI compliance
export const brandConfig = {
  // Brand mappings
  brands: {
    'drw': {
      name: 'DRW',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NAB'
    },
    'her': {
      name: 'HER',
      currency: 'GBP',
      region: 'UK',
      gateway: 'JCC'
    },
    'hvn': {
      name: 'HVN',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Stripe'
    },
    'inv': {
      name: 'INV',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NMI'
    },
    'ip1': {
      name: 'IP1',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Worldpay'
    },
    'bfs': {
      name: 'BFS',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Worldpay'
    },
    'jer': {
      name: 'JER',
      currency: 'GBP',
      region: 'UK',
      gateway: 'JCC'
    },
    'lax': {
      name: 'LAX',
      currency: 'USD',
      region: 'US',
      gateway: 'EVO',
      // hero: {
      //   title: 'test 1',
      //   subtitle: 'test 2'
      // }
    },
    'ldy': {
      name: 'LDY',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Windcave'
    },
    'ml1': {
      name: 'ML1',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Authipay'
    },
    'noc': {
      name: 'NOC',
      currency: 'GBP',
      region: 'UK',
      gateway: 'First'
    },
    'nqy': {
      name: 'NQY',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Stripe'
    },
    'pb1': {
      name: 'PB1',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NAB'
    },
    'pit': {
      name: 'PIT',
      currency: 'USD',
      region: 'US',
      gateway: 'EVO',
      widget: {
        searchButtonText: 'FIND MY PARKING OFFERS',
        searchShowTabs: 'parking,lounge,fasttrack',
        searchActiveTab: 'parking',
        searchHideTabs: true
      },
      hero: {
        title: 'Welcome to Parking at Pittsburgh International Airport',
        subtitle: 'Manage bookings or make another booking'
      }
    },
    'rsw': {
      name: 'RSW',
      currency: 'USD',
      region: 'US',
      gateway: 'EVO'
    },
    'sv1': {
      name: 'SV1',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Stripe',
      widget: {
        searchButtonText: 'Book Now',
        searchShowTabs: 'parking,lounge,fasttrack',
        searchActiveTab: 'parking',
        searchHideTabs: true
      }
    },
    'szg': {
      name: 'SZG',
      currency: 'EUR',
      region: 'EU',
      gateway: 'Payone',
      bookings: {
        hideAirportColumn: true,
      }
    },
    'fmm': {
      name: 'FMM',
      currency: 'EUR',
      region: 'EU',
      gateway: 'Payone',
      widget: {
        searchButtonText: 'Search',
        searchShowTabs: 'parking,lounge,fasttrack,flights',
        searchActiveTab: 'fasttrack',
        searchHideTabs: false
      },
      bookings: {
        hideAirportColumn: true,
      },
      hero: {
        subtitle: 'Here you can make changes to your bookings, change your vehicle plate number or view your tickets.'
      }
    },
    'yhm': {
      name: 'YHM',
      currency: 'CAD',
      region: 'CA',
      gateway: 'Moneris',
      hero: {
        subtitle: 'It’s good to see you today! Here you can access your itinerary, view your receipt and amend or cancel your booking.'
      }
    },
    'gso': {
      name: 'GSO',
      currency: 'USD',
      region: 'US',
      gateway: 'Payone'
    },
    'bhx': {
      name: 'BHX',
      currency: 'GBP',
      region: 'UK',
      gateway: 'Stripe',
      bookings: {
        hideAirportColumn: true,
      },
      widget: {
        searchButtonText: 'Get a Quote ➜',
        searchShowTabs: 'parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours, immigration',
        searchActiveTab: 'parking',
        searchHideTabs: false
      },
    },
    'sb2': {
      name: 'SB2',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NMI',
      widget: {
        searchButtonText: 'SEARCH',
        searchShowTabs: 'parking, seasonalparking',
        searchActiveTab: 'parking',
        searchHideTabs: false
      },
    },
    'sb3': {
      name: 'SB3',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NMI',
      widget: {
        searchButtonText: 'SEARCH',
        searchShowTabs: 'parking, seasonalparking',
        searchActiveTab: 'parking',
        searchHideTabs: false
      },
    },
    'sb4': {
      name: 'SB4',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NMI',
      widget: {
        searchButtonText: 'SEARCH',
        searchShowTabs: 'parking, seasonalparking',
        searchActiveTab: 'parking',
        searchHideTabs: false
      },
    },
    'sb5': {
      name: 'SB5',
      currency: 'GBP',
      region: 'UK',
      gateway: 'NMI',
      widget: {
        searchButtonText: 'SEARCH',
        searchShowTabs: 'parking, seasonalparking',
        searchActiveTab: 'parking',
        searchHideTabs: false
      },
    },
  },

  // Get brand configuration
  getBrand(brandCode) {
    return this.brands[brandCode?.toLowerCase()] || null;
  },

  // Check if brand exists
  isValidBrand(brandCode) {
    return !!this.brands[brandCode?.toLowerCase()];
  },

  // Get all brand codes
  getAllBrands() {
    return Object.keys(this.brands);
  }
};